// extracted by mini-css-extract-plugin
export default {"backToTopButton":"DOe2WerDz_KdoAicyEAg"};